import { ROUTES_SEARCH_RESULTS } from '@/constants/routes';

export default {
    path: '/search-results',
    name: ROUTES_SEARCH_RESULTS,
    component: () => import(/*webpackChunkName: 'search-results'*/ '@/views/SearchResults.vue')
};
